const configured = import.meta.env.VITE_SITE_URL as string | undefined;

// 规范站点源地址，移除末尾多余斜杠，避免 JSON-LD 里出现双斜杠
export const SITE_URL = (configured || "https://usfanslink.study").replace(/\/+$/, "");

// 站点品牌图标（同时作为 Organization 的 logo）
export const SITE_LOGO =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg";